import { Controller } from "@hotwired/stimulus";
import { Dashboard } from '~/javascripts/dashboard';

export default class extends Controller {
  static values = {
    buildingDistribution: Array,
    unitDistribution: Array,
    integrations: Array
  }

  connect() {
    Dashboard.buildingDistributionByIntegrationType.setData(this.buildingDistributionValue);
    Dashboard.unitDistributionByIntegrationType.setData(this.unitDistributionValue);
    Dashboard.integrationsByMonth.setData(this.integrationsValue);
  }
}
